import { gql } from '@apollo/client';

export const GET_RESET_LINKS = gql`
  mutation GetResetLinks($email: String!) {
    getResetLinks(email: $email) {
      resetLinks {
        userType
        fullName
        url
      }
    }
  }
`;
